import React from 'react';
export function EmailClickIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 20a3 3 0 01-3-3V7a3 3 0 013-3h14a3 3 0 013 3v5a1 1 0 11-2 0v-1.613l-7.052 2.35a3 3 0 01-1.897 0L4 10.388V17a1 1 0 001 1h6a1 1 0 110 2H5zM4 8.28l7.684 2.56a1 1 0 00.632 0L20 8.28V7a1 1 0 00-1-1H5a1 1 0 00-1 1v1.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.414 15.5H19a1 1 0 100-2h-5a1 1 0 00-1 1v5a1 1 0 102 0v-2.586l4.293 4.293a1 1 0 001.414-1.414L16.414 15.5z"
  }));
}